import ArrowRightFromLine from "./ArrowRightFromLine.vue";
import ArrowFromLineLeft from "./ArrowFromLineLeft.vue";
import EoHeimatIcon from "./EoHeimatIcon.vue";
import PrincipalSwitch from "./PrincipalSwitch.vue";
import AGT from "./Principallogos/AGT.vue";
import AdAssistent from "./Modules/AdAssistent.vue";
import AdAssistentFilled from "./Modules/Filled/AdAssistentFilled.vue";
import Administration from "./Modules/Administration.vue";
import AdministrationFilled from "./Modules/Filled/AdministrationFilled.vue";
import Ads from "./Modules/Ads.vue";
import AdsFilled from "./Modules/Filled/AdsFilled.vue";
import Bookings from "./Modules/Bookings.vue";
import BookingsFilled from "./Modules/Filled/BookingsFilled.vue";
import Cms from "./Modules/Cms.vue";
import CmsFilled from "./Modules/Filled/CmsFilled.vue";
import Defects from "./Modules/Defects.vue";
import DefectsFilled from "./Modules/Filled/DefectsFilled.vue";
import Events from "./Modules/Events.vue";
import EventsFilled from "./Modules/Filled/EventsFilled.vue";
import Kis from "./Modules/Kis.vue";
import KisFilled from "./Modules/Filled/KisFilled.vue";
import Locations from "./Modules/Locations.vue";
import LocationsFilled from "./Modules/Filled/LocationsFilled.vue";
import News from "./Modules/News.vue";
import NewsFilled from "./Modules/Filled/NewsFilled.vue";
import Poi from "./Modules/Poi.vue";
import PoiFilled from "./Modules/Filled/PoiFilled.vue";
import Maps from "./Modules/Maps.vue";
import MapsFilled from "./Modules/Filled/MapsFilled.vue";
import Prompts from "./Modules/Prompts.vue";
import PromptsFilled from "./Modules/Filled/PromptsFilled.vue";
import Reports from "./Modules/Reports.vue";
import ReportsFilled from "./Modules/Filled/ReportsFilled.vue";
import Web2Print from "./Modules/Web2Print.vue";
import Web2PrintFilled from "./Modules/Filled/Web2PrintFilled.vue";
import PenOutlined from "./PenOutlined.vue";
import GearOutlined from "./GearOutlined.vue";
import ChartOutlined from "./ChartOutlined.vue";
import GridPlusOutlined from "./GridPlusOutlined.vue";
import Route from "./Route.vue";
import Persons from "./Persons.vue";
import Agent from "./Agent.vue";
import MapPin from "./MapPin.vue";
import OYA from "./Principallogos/OYA.vue";
import AppPages from "./AppPages.vue";
import Inbox from "./Inbox.vue";
import Copy from "./Copy.vue";
import Message from "./Message.vue";
import Issue from "./Issue.vue";
import AppStatistics from "./AppStatistics.vue";
import Bell from "./Bell.vue";
import Clicks from "./Clicks.vue";
import UsersOutlined from "./UsersOutlined.vue";
import DownloadOutlined from "./DownloadOutlined.vue";
import Downloads from "./Downloads.vue";
import FileXML from "./FileXML.vue";
import FileZip from "./FileZip.vue";
import FileXLS from "./FileXLS.vue";
import ImageCheck from "./ImageCheck.vue";
import ImageXMark from "./ImageXMark.vue";
import ImageXMarkFilled from "./ImageXMarkFilled.vue";
import AddItemSquare from "./AddItemSquare.vue";
import Filter from "./Filter.vue";
import PrincipalSwitchFilled from "./PrincipalSwitchFilled.vue";
import FileJSON from "./FileJSON.vue";
import FileCsv from "./FileCsv.vue";
import FileImage from "./FileImage.vue";
import MiniSystemLogo from "./MiniSystemLogo.vue";
import LargeSystemLogo from "./LargeSystemLogo.vue";
import AlarmClock from "./AlarmClock.vue";
import LightBulbOn from "./LightBulbOn.vue";
import UsersViewfinder from "./UsersViewfinder.vue";
import Logout from "./Logout.vue";
import CustomizePen from "./CustomizePen.vue";
import AlertTriangle from "./AlertTriangle.vue";
import InfoCircle from "./InfoCircle.vue";
import ListSteps from "./ListSteps.vue";
import Calendar from "./Calendar.vue";
import Forms from "./Modules/Forms.vue";
import FormsFilled from "./Modules/Filled/FormsFilled.vue";
import ChevronDown from "./ChevronDown.vue";
import Eye from "./Eye.vue";
import FloppyDisk from "./FloppyDisk.vue";
import FloppyDiskArrowRight from "@/customIcons/FloppyDiskArrowRight.vue";
import { menuIconConfig } from "./Menu/menuIconConfig";

export const customIcons = {
  ...menuIconConfig,
  customizePen: { component: CustomizePen },
  maps: { component: Maps },
  mapsFilled: { component: MapsFilled },
  logout: { component: Logout },
  largeSystemLogo: { component: LargeSystemLogo },
  miniSystemLogo: { component: MiniSystemLogo },
  fileImage: { component: FileImage },
  fileCsv: { component: FileCsv },
  fileJSON: { component: FileJSON },
  principalSwitchFilled: { component: PrincipalSwitchFilled },
  filter: { component: Filter },
  addItemSquare: { component: AddItemSquare },
  imageXMarkFilled: { component: ImageXMarkFilled },
  imageXMark: { component: ImageXMark },
  imageCheck: { component: ImageCheck },
  fileXLS: { component: FileXLS },
  fileZip: { component: FileZip },
  fileXML: { component: FileXML },
  downloads: { component: Downloads },
  downloadOutlined: { component: DownloadOutlined },
  usersOutlined: { component: UsersOutlined },
  clicks: { component: Clicks },
  bell: { component: Bell },
  appStatistics: { component: AppStatistics },
  issue: { component: Issue },
  message: { component: Message },
  copy: { component: Copy },
  inbox: { component: Inbox },
  appPages: { component: AppPages },
  oya: { component: OYA },
  mapPin: { component: MapPin },
  agent: { component: Agent },
  route: { component: Route },
  persons: { component: Persons },
  gridPlusOutlined: { component: GridPlusOutlined },
  penOutlined: { component: PenOutlined },
  gearOutlined: { component: GearOutlined },
  chartOutlined: { component: ChartOutlined },
  arrowRightFromLine: {
    component: ArrowRightFromLine
  },
  arrowLeftFromLine: {
    component: ArrowFromLineLeft
  },
  eoHeimat: {
    component: EoHeimatIcon
  },
  principalSwitch: {
    component: PrincipalSwitch
  },
  agt: {
    component: AGT
  },
  adAssistent: {
    component: AdAssistent
  },
  adAssistentFilled: {
    component: AdAssistentFilled
  },
  administration: {
    component: Administration
  },
  administrationFilled: {
    component: AdministrationFilled
  },
  ads: {
    component: Ads
  },
  adsFilled: {
    component: AdsFilled
  },
  bookings: {
    component: Bookings
  },
  bookingsFilled: {
    component: BookingsFilled
  },
  cms: {
    component: Cms
  },
  cmsFilled: {
    component: CmsFilled
  },
  defects: {
    component: Defects
  },
  defectsFilled: {
    component: DefectsFilled
  },
  events: {
    component: Events
  },
  eventsFilled: {
    component: EventsFilled
  },
  kis: {
    component: Kis
  },
  kisFilled: {
    component: KisFilled
  },
  locations: {
    component: Locations
  },
  locationsFilled: {
    component: LocationsFilled
  },
  news: {
    component: News
  },
  newsFilled: {
    component: NewsFilled
  },
  poi: {
    component: Poi
  },
  poiFilled: {
    component: PoiFilled
  },
  prompts: {
    component: Prompts
  },
  promptsFilled: {
    component: PromptsFilled
  },
  reports: {
    component: Reports
  },
  reportsFilled: {
    component: ReportsFilled
  },
  web2Print: {
    component: Web2Print
  },
  web2PrintFilled: {
    component: Web2PrintFilled
  },
  AlarmClock: {
    component: AlarmClock
  },
  LightBulbOn: {
    component: LightBulbOn
  },
  UsersViewfinder: {
    component: UsersViewfinder
  },
  AlertTriangle: {
    component: AlertTriangle
  },
  InfoCircle: {
    component: InfoCircle
  },
  listSteps: {
    component: ListSteps
  },
  calendar: {
    component: Calendar
  },
  forms: {
    component: Forms
  },
  formsFilled: {
    component: FormsFilled
  },
  chevronDown: {
    component: ChevronDown
  },
  eye: {
    component: Eye
  },
  floppyDisk: {
    component: FloppyDisk
  },
  floppyDiskArrowRight: {
    component: FloppyDiskArrowRight
  }
};
